export default __webpack_public_path__ + "static/media/japanese.5459410e.svg";